const carouselSlides = [
    { image: "/images/1.jpg", title: "Research day-4 winners 2024" },
    { image: "/images/2.jpg", title: "Workshop on AI&ML, IoT 2024" },
    { image: "/images/4.jpg", title: "Techpreneur 2024" },
    { image: "/images/3.jpg", title: "9th Research day winners 2025" },
    { image: "/images/5.jpg", title: "Best Conference paper (2025) Germany" },
    { image: "/images/100.jpg", title: "Smart India Hackathon winner 2024 " },
    { image: "/images/c1.JPG", title: "EBC-3.0 Winner & ₹50k cash prize" },
];

export default carouselSlides;
